/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Economics_Management23Inputs */

const en__field_enum_tuda_economics_management23 = /** @type {(inputs: _Field_Enum_Tuda_Economics_Management23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics & Management`)
};

const de__field_enum_tuda_economics_management23 = /** @type {(inputs: _Field_Enum_Tuda_Economics_Management23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaft & Management`)
};

/**
* | output |
* | --- |
* | "Economics & Management" |
*
* @param {_Field_Enum_Tuda_Economics_Management23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_economics_management23 = /** @type {((inputs?: _Field_Enum_Tuda_Economics_Management23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Economics_Management23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_economics_management23(inputs)
	return de__field_enum_tuda_economics_management23(inputs)
});
export { _field_enum_tuda_economics_management23 as "_field_enum_TUDA_ECONOMICS_MANAGEMENT" }